import { makeAutoObservable } from 'mobx'
import { AddDocument, AuthorizeValues, Valid } from '../models/Auction'
import { store } from './store'
import agent from '../api/agent'

export default class AuctionDetailsStore {
  constructor() {
    makeAutoObservable(this)
  }

  authorizeUser = async (authorization: AuthorizeValues) => {
    await agent.Auctions.authorize(authorization).then(() => {
      store.bidsStore.setUnauthorizedUser(false)
    })
  }

  insertDocument = async (doc: AddDocument) => {
    await agent.Auctions.addDocument(doc)
  }

  deleteDocument = async (id: string) => {
    await agent.Auctions.deleteDocument(id)
  }

  validateSolvency = async (valid: Valid) => {
    await agent.Auctions.setValid(valid)
  }
}
